import { InjectionToken } from '@angular/core';

export const eshavaDialogData = new InjectionToken<any>('dialogData');
